<template>
  <b-container fluid class="p-0 px-sm-1 pt-sm-1" :style="itemsSize == 0 ? 'display:none;height: 100%':'height: 100%'">
    <b-row no-gutters style="height: 100%">
      <b-col class="" style="height: 100%; padding-bottom: 2px">
        <b-card header-tag="header" header-class="d-none d-md-block" class="d-none d-sm-block"
                :style="(itemsSize <= 1 ? 'display:none !important;':'')
                   + 'position:absolute; width: 100%; height: 100%; z-index: -200; left:-3px; top:-3px'">
          <template v-slot:header>
            <h6 class="mb-0 ">Fake</h6>
          </template>
          <b-card-text>
            &nbsp;
          </b-card-text>
        </b-card>

        <!--          d-none d-md-block-->
        <b-card header-tag="header"
                :header-class="topActivityHeaderClass + ' workspace-card-header py-1 py-md-2 align-middle px-1 px-md-2' +
                   (itemsSize === -1 ? ' d-none' : '')"
                style="height: 100%; margin-bottom: 5px;"
                body-class="workspace-card-body p-0">
          <template v-slot:header>
            <div style="justify-content: space-between; height: 24px" class="align-middle">
              <span class="align-middle h6 d-none d-md-inline pl-1 ellipsis">{{ topActivityTitle }}&nbsp;</span>
              <span class="align-middle h6 d-md-none pl-1 ellipsis">{{ topActivityTitle }}&nbsp;</span>

              <b-btn-close
                  class="d-none d-sm-inline-block"
                  v-if="topActivityIsClosable" @click.stop="closeTopActivity(false)"><span
                  aria-hidden="true">&times;</span></b-btn-close>
            </div>
          </template>
          <div ref="activitiesRoot" data-test-path="activity-workspace" data-workspace-root="true"
               style="position:relative; height: 101%; overflow-y: auto; background-color: white">

          </div>
        </b-card>
      </b-col>
    </b-row>
  </b-container>
</template>


<script>

import Vue from "vue";

import Log from "@/utils/Log";
import Activity from "./Activity";
import ActivityModel from "./ActivityModel";
import ActivityManager from "./ActivityManager";


import EventBus from "@/utils/EventBus";
import Events from "@/utils/Events";
import SessionManager from "@/utils/SessionManager";

import {Stack} from "buckets-js";
import DialogManager from "@/utils/DialogManager";
import PermissionsSet from "@/server/PermissionsSet";

import DashletsHome from "@/components/dashboard/DashletsHome.vue";
import {nextAnimationFrame} from "@/utils/Executors";
import RoutingKeys from "@/server/RoutingKeys";
import {sendEvent} from "@/utils/GEvents";

let instanceId = 0;
let globalActivityInstance = 0;


function rewriteHistory(stepsBack, activities, workspace) {
  workspace.$router.go(-stepsBack);
  waitForLocationChange(100, workspace._computeRoute(), workspace.$router, () => go(activities, workspace));
}

function go(activities, workspace) {
  if (activities.length == 0) {
    workspace._showTopActivity();
    workspace._refreshTrigger();
    return;
  }

  workspace.items.push(activities[0]);
  workspace.itemsSize = workspace.items.size();
  workspace.$router.push(workspace._computeRoute(), () => go(activities.slice(1), workspace));
}

function waitForLocationChange(numberOfTries, awaitedRoute, router, onWaited) {
  if (numberOfTries == 0) {
    onWaited();
    return;
  }

  if (router.currentRoute.fullPath != awaitedRoute) {
    setTimeout(() => waitForLocationChange(numberOfTries - 1, awaitedRoute, router, onWaited), 10);
  } else {
    onWaited();
  }
}

export default {
  name: "ActivityWorkspace",

  components: {DashletsHome},
  created() {
    window["__activityWorkspace"] = this;
    this.instanceId = instanceId++;
    this.activityManager._bindActivityWorkspace(this);
    Log.debug("Activity workspace setup on route:" + this.baseRoute);

    this.waitForResize = false;

    this.resizeObserver = new ResizeObserver(entries => {
      if (this.waitForResize) {
        return;
      }

      this.waitForResize = true;
      if (this.frozen) {
        this.waitForResize = false;
        return;
      }

      if (this.recoverSizeAfterFreeze) {
        this.recoverSizeAfterFreeze = false;
      }

      const root = document.getElementsByClassName('workspace-card-body')[0];

      this.$nextTick(() => // requestAnimationFrame(() =>
              setTimeout(() => {
                this.waitForResize = false;

                for (let el of entries) {
                  if (el.target === root) {
                    this.fixSize();
                  } else {
                    try {
                      EventBus.$emit(Events.sizeChanged);
                    } catch (e) {
                      console.log(e);
                    }
                  }
                }
              })
          //  )
      );
    });
  },

  mounted() {
    document.body.style.overflow = "hidden";
    setTimeout(() => this.fixSize());

    //addListener(, el => this.fixSize(el));
    this.resizeObserver.observe(document.getElementsByClassName('workspace-card-body')[0]);


    this._refreshTrigger();
    this.$onEvent(Events.requestTopActivityClose, () =>
        this.closeTopActivity(false)
    );

    this.$onEvent(Events.requestActivityToShow, (data) =>
        this.showActivity(data.activityClass, data.props)
    );

    this.$onEvent(Events.permissionsChanged, (newPermissions) => {
      let i = 0;
      let activities = this.items.toArray();

      while (i < activities.length) {
        /** @type{Activity} */
        let act = activities[i].activity;
        if (!act.checkRequiredPermissions()) {
          DialogManager.info($tr('permissionsChange', 'Permissions change'),
              $tr('activityWorkspace.admin.reconfigured.permission',
                  'Your administrator reconfigured your permission. Your workspace needs to be refreshed'));
          this.closeActivity(act, true);
          break;
        }
        i++;
      }
    })

    /** @type {string} */
    let currentPath = this.$router.currentRoute.fullPath;

    if (this.baseRoute != currentPath) {
      this._bootstrapFromUrl(this.baseRoute, currentPath);
    }
    EventBus.$emit(Events.workspaceShow, this.items);
    setTimeout(() => {
      SessionManager.workspaceCreated();
      this.$subscribe(RoutingKeys.DIALOG_MANAGER_INFO_COMPANY_EXIST, async (message) => {
        console.log("message" + message);
        let choose = await DialogManager.binaryOptionDialog(
        $tr("binaryOptionDialog.creatingNewOrganization", "Creating a new organization"),
        $tr("binaryOptionDialog.exists.name", "The organization with the name entered exists. Choose what you want to do."),
        $tr("binaryOptionDialog.createButton","Create organizations with a different name"),
        $tr("binaryOptionDialog.addButton","Add me to an existing company"));
        console.log("choose : "+choose)
        if(choose.success && choose.isNewOrganization){
          let isCorrectName = true;
          while(isCorrectName){
            isCorrectName = await Rpc.plm.services.marketPlace.services.InvitationBaseService.checkNameOrganization(await DialogManager.lineInput(
                    $tr("binaryOptionDialog.creatingNewOrganization", "Creating a new organization"),
                    $tr("binaryOptionDialog.enter", "Enter the name of the organization"),
                    null, {okTitle: $tr("inputLine.ok","Ok"),
                      cancelTitle: $tr("inputLine.Cancel","Cancel")}),
                message.shortName, message.silkOrganizationIdSender);
            if(isCorrectName){
              await DialogManager.info(
                  $tr("binaryOptionDialog.attention","Attention"),
                  $tr("binaryOptionDialog.alreadyExist","This organization name already exists, enter a different organization name."));
            }
          }
        }
        if(choose.success && !choose.isNewOrganization){

        }
      });
      this.$nextTick(args => {
        this.showActivity(DashletsHome);
      });
    });
  },


  activated() {
    Log.trace("Workspace activated");
    this.frozen = false;
    if (this.frozenUrl) {
      this._reactToRouteChange(this.$router.currentRoute.fullPath, this.frozenUrl);
    }
    EventBus.$emit(Events.workspaceShow, this.items);
  },
  deactivated() {
    this.frozen = true;
    this.frozenUrl = this.$router.currentRoute.fullPath;

    Log.trace("Workspace deactivated");
    EventBus.$emit(Events.workspaceHide, this.items);
  },
  beforeDestroy() {
    this.frozen = true;
  },
  methods: {
    sizeAdjusted(newH) {
    },
    enableFade() {
      this.fadeEnabled = true;
    },
    disableFade() {
      this.fadeEnabled = false;
    },

    fixSize(el) {
      setTimeout(() => {
        if (this.resizePending) {
          return
        }
        this.resizePending = true;

        let topAct = this.getTopActivity()?.$el;
        let scrollStyle = "";
        if (topAct && topAct.$el) {
          scrollStyle = topAct.$el.style.overflowY;
          if (topAct.$el.scrollHeight > topAct.$el.clientHeight) {
            topAct.$el.style.overflowY = "always";
          } else {
            topAct.$el.style.overflowY = "hidden";
          }
        }

        if (this.$refs.activitiesRoot?.scrollHeight > this.$refs.activitiesRoot?.clientHeight) {
          if (this.$refs.activitiesRoot?.style) {
            this.overflow = "always";
            this.resetWorkspaceStyle();
            this.$refs.activitiesRoot.style.overflowY = "always";
          } else {
          }
        } else {
          if (this.$refs.activitiesRoot?.style) {
            this.overflow = "hidden";
            this.resetWorkspaceStyle();
            this.$refs.activitiesRoot.style.overflowY = "hidden";
          } else {
          }
        }

        setTimeout(() => {
          this.resizePending = false;
          setTimeout(() => {
            requestAnimationFrame(() => {
              setTimeout(() => {
                this.overflow = "auto";
                this.resetWorkspaceStyle();
                this.$refs.activitiesRoot.style.overflowY = "auto";
                if (topAct && topAct.$el) {
                  topAct.$el.style.overflowY = scrollStyle;
                }
              });
            });
          });

          let heightOfCardBody = document.getElementsByClassName('workspace-card-body')[0].offsetHeight;
          this.height = `${heightOfCardBody}px`;
          this.resetWorkspaceStyle();
          this.$refs.activitiesRoot.style.height = `${heightOfCardBody}px`;

          EventBus.$emit(Events.sizeChanged, {workspaceHeight: heightOfCardBody});

          if (this.getTopActivity() != null) {
            this.getTopActivity().sizeAdjusted(heightOfCardBody);
          }


          if (this.prevSize >= 0) {
            setTimeout(() => {
              let rootDiv = Activity.findActivityRootDiv(document.activeElement);
              if (document.activeElement && rootDiv) {
                const rect = document.activeElement.getBoundingClientRect();
                const inViewport =
                    rect.top >= 80 &&
                    rect.bottom + 60 <= (window.innerHeight || document.documentElement.clientHeight);

                Log.debug("Moving scroll:" + inViewport);
                let scrollable = document.activeElement.parentElement;
                if (inViewport) {
                  return;
                }
                let delta = 0;
                // if(rect.top<0){
                //   delta = rect.top - 5;
                // } else {
                //   delta = -rect.bottom + (window.innerHeight || document.documentElement.clientHeight) +5;
                // }

                delta = rect.top - 80;

                while (true) {
                  if (!scrollable || scrollable === this.$el) {
                    break;
                  }
                  let style = getComputedStyle(scrollable);
                  if (style.overflowY === "auto" || style.overflowY === "scroll") {

                    let newScroll = scrollable.scrollTop + delta;
                    if (newScroll < 0) {
                      newScroll = 0;
                    }

                    //console.log(scrollable);
                    Log.debug("Moving scroll:" + delta);
                    scrollable.scrollTop = newScroll;

                    break;
                  }
                  scrollable = scrollable.parentElement;
                }
              }
            });
          }
          this.prevSize = heightOfCardBody;
        });
      })
    },

    showActivity(activityClass, createParameters, traceLabel) {
      let lbl = traceLabel ?? activityClass.name;
      Rpc.Interactions.event("activity-" + lbl, {name: lbl}).then();
      sendEvent("ac-" + lbl, {name: lbl});

      if (createParameters === undefined) {
        createParameters = {};
      }

      /** @type {ActivityModel} */
      let act = this.items.toArray().find(model => {
        return model.componentName === activityClass.name;
      });

      if (act) {
        if (act.activity.multipleInstances() === "BLOCK") {
          Log.trace("Multiple instance of activity: " + act.componentName + " blocked");
          return act.activity;
        }
        if (act.activity.multipleInstances() === "BUBBLE") {
          Log.trace("Bubbling activity: " + act.componentName);
          if (this.items.peek() === act) {
            this.itemsSize = this.items.size();
            return act.activity;
          }
          this.itemsSize = this.items.size();

          this._hideTopActivity();

          let activitiesReordered = new Stack();
          activitiesReordered.push(act);
          let item;

          let stepsBack = 1;
          while (act !== (item = this.items.pop())) {
            this.itemsSize = this.items.size();
            stepsBack++;
            activitiesReordered.push(item);
          }
          this.itemsSize = this.items.size();

          this.inRouteManipulation = true;
          rewriteHistory(stepsBack, activitiesReordered.toArray(), this);
          this.inRouteManipulation = false;
          this.refreshWorkspaceUI();

          return act.activity;
        }
      }


      let model = new ActivityModel();

      let ComponentClass = this.getComponentClass(activityClass);
      /** @type {Activity} */
      let instance = new ComponentClass({propsData: createParameters});
      if (activityClass.hasOwnProperty("permission")) {
        instance.permission = activityClass.permission;
      }
      instance.unmountTriggers = [];

      if (!instance.checkRequiredPermissions()) {
        DialogManager.info($tr('missingPermissions', 'Missing permissions'),
            $tr('activityWorkspace.account.not.enough.permissions',
                'Your account has not enough permissions to run this activity. \n ' +
                'Please contact your administrator to get access.'));
        return null;
      }

      if (typeof instance.beforeMount !== "function") {
        let name = "";
        if (activityClass.name !== undefined) {
          name = activityClass.name;
          Log.fatal(
              "Component " + name + " doesn't extend Activity class"
          );
        } else {
          name = JSON.stringify(activityClass);
          Log.fatal(
              "Component doesn't extend Activity class: \n" + name
          );
        }
        return null;
      }

      instance._bindActivityManager(this.activityManager);
      model.bind(instance);

      model.componentName = activityClass.name;
      Log.action("activity-created", model.componentName, "");

      model.activityResultPromise = new Promise((resolve, reject) => {
        model.activityResultPromiseResolve = resolve;
      });
      model.updateSnapshot();

      instance.beforeMount();
      this.$children.push(instance);
      instance.$parent = this;
      instance.$root = this.$root;
      //instance.$vuetify = this.$vuetify;
      instance.$mount();
      this._installProxies(instance, activityClass, model);

      model.id = globalActivityInstance++;
      let div = document.createElement("div");
      div.setAttribute("data-test-path", "activity-" + model.id);
      div.setAttribute("data-activity-root", "true");
      div.setAttribute("data-activity-class", activityClass.name);
      div.setAttribute("data-activity-instance-id", "" + model.id);
      div.style.position = "absolute";
      div.style.left = "0";
      div.style.top = "0";
      div.style.right = "0";
//      div.classList.add("activity-fade-in");

      //div.setAttribute("style", "height:100%");
      this.$refs.activitiesRoot.appendChild(div);
      div.appendChild(instance.$el);
      model.activityRootNode = div;
      model.activityRootNode.style.zIndex = "100";
      model.activityRootNode.classList.add("activity-hidden");
      //model.activityRootNode.style.opacity = "0";
      this.$nextTick(() => {
        // requestAnimationFrame(()=>{
        //   requestAnimationFrame(()=>{
        model.activityRootNode.classList.remove("activity-hidden");
        model.activityRootNode.classList.add("activity-top");
        // model.activityRootNode.style.opacity = "1";
        setTimeout(() => {
          instance.afterMount();
          //   });
          // });
        })
      });

      model.workspace = this;
      this.resizeObserver.observe(model.activityRootNode);

      // addListener(model.activityRootNode);

      this._hideTopActivity();
      this.waitingForReopen = false;

      this.items.push(model);
      this.itemsSize = this.items.size();

      this.inRouteManipulation = true;
      if (this.$router.currentRoute.fullPath != this._computeRoute()) {
        this.$router.push(this._computeRoute()).then(() => {
          this.inRouteManipulation = false;
        });
      }

      emulateClick(instance.$el);

      nextAnimationFrame(() => {
        setTimeout(() => {
          this.fixSize();
          instance.afterShow();
        });
      });

      this._refreshTrigger();
      return instance;
    },

    getComponentClass(activityClass) {
      if (!this.componentStore) {
        this.componentStore = new Map();
      }

      let signature = activityClass.name;
      for (const k in activityClass) {
        if (k === 'methods' || k === 'props') {
          for (const k2 in (activityClass[k] ?? {})) {
            signature += ":" + k2;
          }
        }
        signature += "-" + k;
      }

      if (this.componentStore.has(signature)) {
        return this.componentStore.get(signature);
      }

      let newMounted = null;
      if (activityClass.hasOwnProperty("mounted")) {
        newMounted = async function () {
          await activityClass.mounted.call(this);
          this.__mounted = true;
          await new Promise((resolve, reject) => {
            setTimeout(resolve)
          });
          return await this._autostart();
        }
      } else {
        newMounted = async function () {
          this.__mounted = true;
          await new Promise((resolve, reject) => {
            setTimeout(resolve)
          });
          return await this._autostart();
        }
      }

      let newCreated = null;
      if (activityClass.hasOwnProperty("created")) {
        newCreated = async function () {
          await activityClass.created.call(this);
          this.__created = true;
          await new Promise((resolve, reject) => {
            setTimeout(resolve)
          });
          return await this._autostart();
        }
      } else {
        newCreated = async function () {
          this.__created = true;
          await new Promise((resolve, reject) => {
            setTimeout(resolve)
          });
          return await this._autostart();
        }
      }

      let opt = {...activityClass, router: this.$router, mounted: newMounted, created: newCreated}
      let clazz = Vue.extend(opt);
      this.componentStore.set(signature, clazz);
      return clazz;
    },
    //
    // reactivateResizeObservers(){
    //   let model = this.items.peek();
    //   if(!model){
    //     return;
    //   }
    //   addListener(model.activityRootNode, model.resizeCallback);
    // },
    //
    // holdResizeObservers(){
    //   let model = this.items.peek();
    //   if(!model){
    //     return;
    //   }
    //
    //   removeListener(model.activityRootNode, model.resizeCallback);
    // },


    /**
     * @param {Activity} activity
     * @param {boolean} force
     */
    async closeActivity(activity, force) {
      let model = this._findActivityModel(activity);
      if (model) {
        return this.closeChain(model, force, true);
      } else {
        Log.debug("Closing activity out of stack");
        return false;
      }
    },
    /**
     * @param {ActivityModel} activityModel
     * @param {boolean} [force=false]
     * @param {boolean} [includeActivity=false]
     * @return {Promise<*>}
     */
    async closeChain(activityModel, force, includeActivity) {
      let activities = this.items.toArray();
      let i = 0;
      let found = false;

      while (i < activities.length) {
        if (activities[i] == activityModel) {
          found = true;
          break;
        }
        i++;
      }
      if (includeActivity) {
        i++;
      }

      Log.trace("Close chain of " + i + " requested");
      if (i == 0) {
        return false;
      }

      let closed = await this._closeTopActivities(i, force);
      if (closed == 0) {
        return false;
      }

      //this.$router.go(-closed);
      await this.goNBack(closed);
      if (!this._compareRoutes(this.$router.currentRoute.fullPath, this._computeRoute())) {
        this.$router.replace(this._computeRoute()).then(() => this.inRouteManipulation = false);
      } else {
        this.inRouteManipulation = false;
      }

      this.refreshWorkspaceUI();
      return true;
    },

    findActivityById(id) {
      let activities = this.items.toArray().reverse();
      for (let i in activities) {
        if (activities[i].id === parseInt(id)) {
          return activities[i].activity;
        }
      }
      return null;
    },

    async closeAll(force = false) {
      let n = this.items.size();
      let closed = await this._closeTopActivities(n, force, force);
      await new Promise(resolve => {
        setTimeout(() => resolve());
      });
    },

    /**
     * @param { {activityClass:*, props:Object, traceLabel:string }[] } activities
     */
    async replaceActivities(activities) {
      let n = this.items.size();
      let closed = await this._closeTopActivities(n, false, true);
      if (closed != n && this.items.size() != 1) {
        return null;
      }

      //Log.trace("replaceActivities - after _closeTopActivities() " + Date.now());

      let last = null;
      this.inRouteManipulation = true;
      if (this.$router.currentRoute.path != this.baseRoute) {
        await this.$router.replace(this.baseRoute);
      }
      this.inRouteManipulation = false;
      activities.forEach(spec => {
        last = this.showActivity(spec.activityClass, spec.props, spec.traceLabel);
      });

      return last;
    },

    async goNBack(n) {
      for (let i = 0; i < n; i++) {
        await this.go1Back();
      }
    },
    async go1Back() {
      return new Promise(resolve => {
        this.inRouteManipulation = true;

        const callback = () => {
          window.removeEventListener("popstate", callback);
          this.inRouteManipulation = false;
          resolve(true);
        }
        window.addEventListener("popstate", callback);

        this.$router.go(-1);
      });
    },

    /**
     * @param {boolean} force
     * @return {Promise<boolean>} true if close was successfull; false if not
     */
    async closeTopActivity(force) {
      Log.trace("Close top activity requested; force=" + force);

      if (1 === await this._closeTopActivities(1, force, false)) {
        await this.go1Back();
        return true;
      }
      return false;
    },

    async closeTopActivityForReopen(force) {
      Log.trace("Close top activity requested; force=" + force);

      if (1 === await this._closeTopActivities(1, force, false, true)) {
        this.waitingForReopen = true;
        await this.go1Back();
        return true;
      }
      return false;
    },


    /**
     * @param {Activity} activity
     * @param {*} result
     */
    setActivityResult(activity, result) {
      this._findActivityModel(activity).activityResult = result;
    },

    /**
     * @param {Activity} activity
     * @return {Promise<*>}
     */
    getActivityResult(activity) {
      return this._findActivityModel(activity).activityResultPromise;
    },

    /**
     * @param {Activity} activity
     * @return {boolean}
     */
    isActivityOnStack(activity) {
      return this._findActivityModel(activity) != null;
    },

    /**
     * @param {Activity} activity
     * @return {boolean}
     */
    isActivityOnTop(activity) {
      return this._findActivityModel(activity) == this.items.peek();
    },

    _blinkOnBar(activity) {
      // TODO
    },

    getTopActivity() {
      if (this.items.isEmpty()) {
        return null;
      }

      return this.items.peek().activity;
    },

    getTopActivityId() {
      if (this.items.isEmpty()) {
        return null;
      }

      return this.items.peek().id;
    },

    getBackActivity() {
      let arr = this.items.toArray();
      if (arr.length < 2) {
        return null;
      }

      return arr[1].activity;
    },

    getBackActivityId() {
      let arr = this.items.toArray();
      if (arr.length < 2) {
        return null;
      }

      return arr[1].id;
    },

    getActivitiesStack() {
      return this.items;
    },

    refreshWorkspaceUI() {
      if (this.getTopActivity() != null) {
        this.topActivityTitle = this.getTopActivity().getTitle();
        let type = this.getTopActivity().getActivityType();
        if (!type) {
          this.topActivityHeaderClass = "";
        } else {
          this.topActivityHeaderClass = "activity-hdr-" + type;
        }

        this.topActivityIsClosable = this.getTopActivity().isClosable();
      } else {
        this.topActivityTitle = "";
        this.topActivityHeaderClass = "";
      }
    },
    /**
     * @param {string} expectedRoute
     * @param {string} currentPath
     */
    _bootstrapFromUrl(expectedRoute, currentPath) {
      if (currentPath.startsWith(expectedRoute)) {
        let bootstrapUrl = currentPath.substring(expectedRoute.length);
        Log.trace("Trying to bootstrap activities from url: " + bootstrapUrl);


        this.activityManager.bootstrapWorkspaceFromPath(bootstrapUrl);
      } else {
        Log.debug(
            "Activity workspace fixing route from: " +
            this.$router.currentRoute.fullPath +
            " to: " +
            expectedRoute
        );
        this.inRouteManipulation = true;
        this.$router.replace(expectedRoute).then(() => this.inRouteManipulation = false);
      }
    },

    /**
     * @param {Object} instance
     * @param {Object} componentDefinition
     * @param {ActivityModel} activityModel
     */
    _installProxies(instance, componentDefinition, activityModel) {

      let originalDataModel = instance.$data ?? componentDefinition.data?.() ?? {};

      for (let fieldName in originalDataModel) {
        let descriptor = Object.getOwnPropertyDescriptor(instance, fieldName);

        let originalSetter = descriptor.set;
        let originalGetter = descriptor.get;

        delete instance[fieldName];
        let k = fieldName;
        instance.__activityModel = activityModel;

        Object.defineProperty(instance, k, {
          get: function () {
            return originalGetter.call(this);
          },
          set: function (v) {
            //tu mamy nazwe roli i id
            //setDynamicPermissions()

            if (originalGetter.call(this) === v) {
              return;
            }
            originalSetter.call(this, v);

            if (this.__activityModel.snapshotToUpdate) {
              return;
            }
            this.__activityModel.snapshotToUpdate = true;
            setTimeout(() => {
              Log.trace("Triggering Activity refresh after change in data model: " + k);
              //if(this.__activityModel.updateSnapshot()){
              this.__activityModel.activity?._refreshTrigger?.();
              //}
              this.__activityModel.snapshotToUpdate = false;
            });
          }
        });
      }


    },

    _refreshTrigger() {
      if (!this.refreshRerequest) {
        this.refreshRerequest = true;
        setTimeout(() => {
          this._refreshTriggerExecutor()
        });
      }
    },

    _refreshTriggerExecutor() {
      if (this.refreshRerequest) {
        this.refreshRerequest = false;
        this.refreshWorkspaceUI();
        EventBus.$emit(Events.onActivitiesStackChange, this.items);
        setTimeout(() => {
          this._refreshTriggerExecutor()
        });
      }
    },


    _computeRoute() {
      let r = this.baseRoute;
      if (!r.endsWith("/") && this.items.size() > 0) {
        r += "/";
      }
      return (
          r +
          this.items
              .toArray()
              .reverse()
              .map(e => e.getRoutePart())
              .join("/")
      );
    },

    _hideTopActivity() {
      if (this.waitingForReopen) {
        return;
      }
      if (this.items.isEmpty()) {

        Log.trace("Activity workspace empty - nothing to hide");
        return;
      }

      /**@type {ActivityModel} */
      let top = this.items.peek();
      Log.trace("Hiding top activity: " + top.activity.getTitle());

      top.activity.beforeHide();
      top.activity._runOnHideCallbacks();
      top.persistedDisplayStyle = top.activityRootNode.style !== undefined ? top.activityRootNode.style.display : null;
      // top.activityRootNode.style.opacity = "0";
      top.activityRootNode.style.zIndex = "1";
      top.activityRootNode.classList.remove("activity-top");
      top.activityRootNode.classList.add("activity-hidden");

      setTimeout(() => {
        top.activityRootNode.style.display = "none";
      }, 100);
      setTimeout(() => top.activity.afterHide());
    },

    _showTopActivity() {
      if (this.items.isEmpty()) {

        Log.trace("Activity workspace empty - nothing to show");
        return;
      }

      /**@type {ActivityModel} */
      let top = this.items.peek();
      Log.trace("Showing top activity: " + top.activity.componentName);

      top.activity.beforeShow();
      top.activity._runOnShowCallbacks();

      if (!top.persistedDisplayStyle) {
        top.activityRootNode.style.removeProperty("display");
      } else {
        top.activityRootNode.style.display = top.persistedDisplayStyle;
      }
      top.activityRootNode.classList.add("activity-hidden");
//      top.activityRootNode.style.opacity = "0";
      top.activityRootNode.style.zIndex = "100";

      setTimeout(() => {
        this.fixSize();
        requestAnimationFrame(() => {
          top.activityRootNode?.classList?.remove("activity-hidden");
          top.activityRootNode?.classList?.add("activity-top");
//        top.activityRootNode.style.opacity = "1";
        });
        top.activity.afterShow();
      });
    },

    /**
     * @param {Activity} activity
     * @return {ActivityModel}
     */
    _findActivityModel(activity) {
      let model = null;
      this.items.forEach(activityModel => {
        if (activityModel.activity === activity) {
          model = activityModel;
          return false;
        }
      });

      return model;
    },

    /**
     * @param {function(Activity)} callback
     * @return {[]}
     */
    _forEachActivity(callback) {
      let res = [];
      this.items.forEach(activityModel => {
        res.push(callback(activityModel.activity));
      });

      return res;
    },

    _compareRoutes(a, b) {
      if (!a.endsWith("/")) {
        a = a + "/";
      }

      if (!b.endsWith("/")) {
        b = b + "/";
      }

      return a == b;
    },


    /**
     * @return {Promise<number>}
     */
    async _closeTopActivities(n, force, forceHard, forReopen) {
      Log.trace("Closing top " + n + " activities requested");

      if (this.items.isEmpty()) {
        return 0;
      }
      let firstVisible = true;
      for (let i = 0; i < n; i++) {
        /**@type {ActivityModel} */
        let top = this.items.peek();

        if (!top.activity.isClosable() && !forceHard) {
          if (i > 0) {
            this._showTopActivity();
            this._refreshTrigger();
          }
          return i;
        }

        let canClose = true;
        if (!force) {
          canClose = await top.activity.canClose();
        }

        if (!canClose) {
          if (i > 0) {
            this._showTopActivity();
            this._refreshTrigger();
          }
          return i;
        }
        //console.log("Detaching top:", top.resizeCallback);

        //Log.trace("before beforeClose() " + Date.now());
        top.activity.beforeClose();
        if (firstVisible) {
          if (i === 0) {
//            top.activityRootNode.style.opacity = "0";
            top.activityRootNode.classList.remove("activity-top");
            top.activityRootNode.classList.add("activity-hidden");
            top.activityRootNode.style.zIndex = "1";
            // await new Promise(resolve => {
            //   setTimeout(() => {
            top.activityRootNode.style.display = "none";
            //   resolve(true);
            // }, 990);
            //});
          }
          firstVisible = false;
        }
        //this.(top.activityRootNode, top.resizeCallback);
        this.resizeObserver.unobserve(top.activityRootNode);
        try {
          top.activity.beforeUnmount();
        } finally {
          this.$refs.activitiesRoot.removeChild(top.activityRootNode);
          top.activity.unmountTriggers.forEach(callback => {
            try {
              if (callback) {
                callback();
              }
            } catch (e) {
              console.log(e);
              Log.fatal(e);
            }
          });
          top.activity.unmountTriggers = [];
          top.activity.$destroy();
          const index = this.$children.indexOf(top.activity);

          if (index > -1) {
            this.$children.splice(index, 1);
          }

          this.items.pop();
          this.itemsSize = this.items.size();

          if (!forReopen) {
            this._showTopActivity();
            this._refreshTrigger();
          }
          //Log.trace("Activity before afterUnmount(): "+ Date.now());
          setTimeout(() => {
            try {
              top.activity.afterUnmount();
              Log.action("activity-closed", top.componentName, "tm:" + (performance.now() - top.bindTime));
            } finally {
              try {
                top.activityResultPromiseResolve(top.activityResult);
              } finally {
                setTimeout(() => {
                  //Log.trace("Activity before destroyed: " + top.activity.getTitle()+ " " + Date.now());
                  this._detach(top.activity);
                  top.activity.onDestroy();
                  top.activity.__onShowCallbacks = null;
                  top.destroy();
                  //Log.trace("Activity destroyed: " + top.activity.getTitle()+ " " + Date.now());
                });
              }
            }
          });
        }
      }

      if (n > 0 && !forReopen) {
        this._showTopActivity();
        this._refreshTrigger();
      }

      return n;
    },

    _detach(activity) {
      for (let i in activity._data) {
        if (activity._data[i] && activity._data[i] instanceof PermissionsSet) {
          activity._data[i].detach();
          Log.trace("Detached permissionsSet")
        }
      }
    },
    async _reactToRouteChange(to, from) {
      let prevHistorySize = this.lastHistorySize;
      this.lastHistorySize = window.history.length;
      if (this.frozen) {
        return;
      }

      if (this.inRouteManipulation) {
        return;
      }

      let expected = this._computeRoute();
      if (expected == to.fullPath) {
        return;
      }

      Log.debug(
          '[' + this.instanceId + "] Router event detected " +
          from.fullPath +
          "  ==>  " +
          to.fullPath
      );


      if (to.fullPath.length > expected.length) {
        if (from.fullPath === expected) {
          Log.trace("Forward detected: " + expected);
          await this.go1Back();
          return;
        }
        Log.debug("Unexpected path found: " + expected);
        await this.go1Back();

        this.inRouteManipulation = true;
        this.$router.replace(expected).then(() => this.inRouteManipulation = false);
        return;
      }

      let backButton = this._compareRoutes(expected, from.fullPath) && prevHistorySize == this.lastHistorySize;

      let i = 0;
      let activities = this.items.toArray().reverse();
      this.itemsSize = this.items.size();

      let r = this.baseRoute;
      if (!r.endsWith("/")) {
        r += "/";
      }

      let validPath = expected;
      let missing = [];

      let navigationTarget = to.fullPath;
      if (!navigationTarget.endsWith("/")) {
        navigationTarget += "/";
      }
      while (!navigationTarget.startsWith(validPath)) {
        i++;
        let act = activities.pop();
        if (!act) {
          break;
        }
        missing.push(act);
        Log.debug(
            "Detected missing activity on path: " +
            navigationTarget +
            "; expected path:" +
            expected
        );
        validPath = r + activities.map(e => e.getRoutePart()).join("/");
      }

      let closed = await this._closeTopActivities(missing.length, true);
      this.inRouteManipulation = true;

      if (!backButton) {
        for (let i = 0; i < closed + 1; i++) {
          await this.go1Back();
        }
        //this.$router.go(-(closed+1));
      }
      await new Promise((r, f) => setTimeout(r));
      if (!this._compareRoutes(this.$router.currentRoute.fullPath, this._computeRoute())) {
        this.$router.replace(this._computeRoute()).then(() => this.inRouteManipulation = false);
      } else {
        this.inRouteManipulation = false;
      }
    },
    resetWorkspaceStyle() {
      this.workspaceStyle = `position:relative; height: ${this.height}; overflow-y: ${this.overflow};`;
    }

  },
  watch: {
    $route(to, from) {
      this._reactToRouteChange(to, from);
    }
  },

  props: {baseRoute: String},
  data: function () {
    return {
      prevSize: -1,
      activityManager: ActivityManager,
      frozen: false,
      frozenUrl: null,
      instanceId: -1,
      lastHistorySize: null,
      items: new Stack(),

      itemsSize: 0,
      topActivityTitle: "",
      topActivityIsClosable: false,

      inRouteManipulation: false,
      workspaceAreaHeight: '50px',
      topActivityHeaderClass: "",
      fadeEnabled: true,
      height: "150px",
      overflow: "auto"
    };
  }
};
</script>